import { ThemeBlockShadowValue, FormBlockShadowValue } from '../Properties/BlockShadowValue.js';
import PropertyType from '../Modifiers/PropertyType.js';

var BlockShadowStyleOptions = /*#__PURE__*/function (BlockShadowStyleOptions) {
  BlockShadowStyleOptions["none"] = "none";
  BlockShadowStyleOptions["light"] = "light";
  BlockShadowStyleOptions["retro"] = "retro";
  return BlockShadowStyleOptions;
}(BlockShadowStyleOptions || {});
var ThemeBlockShadowStyleValues = function ThemeBlockShadowStyleValues(shadowStyle) {
  var shadowValue = ThemeBlockShadowValue.getValue();
  switch (shadowStyle) {
    case BlockShadowStyleOptions.retro:
      return "2.5px 2.5px 0 " + shadowValue;
    case BlockShadowStyleOptions.light:
      return "0 0 2px " + shadowValue;
    case BlockShadowStyleOptions.none:
      return 'none';
  }
};
var FormBlockShadowStyleValues = function FormBlockShadowStyleValues(shadowStyle) {
  var shadowValue = FormBlockShadowValue.getValue();
  switch (shadowStyle) {
    case BlockShadowStyleOptions.retro:
      return "2.5px 2.5px 0 " + shadowValue;
    case BlockShadowStyleOptions.light:
      return "0 0 2px " + shadowValue;
    case BlockShadowStyleOptions.none:
      return 'none';
  }
};

// we'll need to limit how the color gets input into the shadow function
// because we're expecting rgb values, but want to set the opacity to be fixed
var themeShadowFunction = function themeShadowFunction(shadowStyle) {
  var shadowValue = ThemeBlockShadowValue.getValue();
  switch (shadowStyle) {
    case BlockShadowStyleOptions.retro:
      return "box-shadow: 2.5px 2.5px 0 " + shadowValue + ";";
    case BlockShadowStyleOptions.light:
      return "box-shadow: 0 0 2px " + shadowValue + ";";
    case BlockShadowStyleOptions.none:
      return 'box-shadow: none;';
    default:
      return;
  }
};
var formShadowFunction = function formShadowFunction(shadowStyle) {
  var shadowValue = FormBlockShadowValue.getValue();
  switch (shadowStyle) {
    case BlockShadowStyleOptions.retro:
      return "box-shadow: 2.5px 2.5px 0 " + shadowValue + ";";
    case BlockShadowStyleOptions.light:
      return "box-shadow: 0 0 2px " + shadowValue + ";";
    case BlockShadowStyleOptions.none:
      return 'box-shadow: none;';
    default:
      return;
  }
};
var ThemeBlockShadowStyle = new PropertyType({
  name: 'BlockShadowStyle',
  propertyFromApi: 'block-shadow-style',
  convertValueToCssPropertiesFunction: themeShadowFunction,
  defaultValue: 'none',
  options: BlockShadowStyleOptions,
  selector: '.block',
  isCompounded: true,
  cssVariable: '--block-shadow',
  cssVariableFunction: function cssVariableFunction(value) {
    return ThemeBlockShadowStyleValues(value);
  }
}, 'theme');
var FormBlockShadowStyle = new PropertyType({
  name: 'BlockShadowStyle',
  propertyFromApi: 'block-shadow-style',
  convertValueToCssPropertiesFunction: formShadowFunction,
  defaultValue: 'none',
  options: BlockShadowStyleOptions,
  selector: '.block',
  isCompounded: true,
  cssVariable: '--block-shadow',
  cssVariableFunction: function cssVariableFunction(value) {
    return FormBlockShadowStyleValues(value);
  }
}, 'form');

export { FormBlockShadowStyle, ThemeBlockShadowStyle };
//# sourceMappingURL=BlockShadowStyle.js.map
